import { Inject, Injectable } from '@angular/core';
import { Report } from '../../models/dashboard/report';
import { Config } from '../../models/dashboard/config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Options } from '../../models/dashboard/options';
import { ConfigService } from '@uxdf/direct-shared-lib';
import { dasboardPDTResponse, enableDashboardMockData } from '../../../mock/dashboard.mock';

@Injectable({
  providedIn: 'root'
})
export class BackendService {
  url = {
    config: (storeCode: string) => 'rest/' + storeCode + '/V1/amadeus/public/dashboard/config',
    report: () => 'api/amadeus/dashboard'
  };

  constructor(
    private readonly httpClient: HttpClient,
    private readonly initService: ConfigService
  ) {}

  getDashboardConfig(storeCode: string): Observable<Config> {
    return this.httpClient.get<Config>(this.initService.getEnvConfig().AD_MAGENTO_URL + this.url.config(storeCode));
  }

  getDashboardData(options: Options): Observable<Report> {
    const paramsObj = Object.entries({ ...options, ...options.filters })
      .filter(
        ([key, value]) => ['filters', 'selectedReport'].indexOf(key) === -1 && value !== undefined && value !== ''
      )
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
    // for mocking dashboard data only in PDT env
    if (enableDashboardMockData &&
      this.initService.getEnvConfig().AD_JAVA_API_URL.localeCompare('https://sit.amadeus-direct.com/') === 0) {
      return of(JSON.parse(JSON.stringify(dasboardPDTResponse)));
    }
    return this.httpClient.get<Report>(this.initService.getEnvConfig().AD_JAVA_API_URL + this.url.report(), {
      params: new HttpParams({ fromObject: paramsObj })
    });
  }
}
